import { DMEData, generalSettings, registerWidget } from "dmeditor";
import { Facebook } from "./Facebook";

const register = () => {
  registerWidget(
    {
      type: "facebook",
      icon: "",
      name: "Facebook",
      category: "basic",
      settings: [
        {
          name: "Facebook url",
          property: ".url",
          settingComponent: "input",
        },
        {
          name: "Height",
          property: ".height",
          settingComponent: "number",
        },
        ...generalSettings,
      ],
      events: {
        updateData: () => {},
        createBlock: (): DMEData.CreatedBlock => {
          return {
            type: "facebook",
            data: { list: [] },
          };
        },
      },
    },
    {
      render: Facebook,
    }
  );
};

export default register;
